<a
  (click)="onClick.emit($event)"
  *ngIf="linkUrl() && linkTitle()"
  [class.apricot]="color() === 'apricot'"
  [class.btn-outline-green]="color() === 'outline-green'"
  [class.btn-outline-tertiary-green]="color() === 'outline-tertiary-green'"
  [class.btn-outline-tertiary]="color() === 'outline-tertiary'"
  [class.btn-outline]="color() === 'outline'"
  [class.bullet]="expanded() === 'bullet'"
  [class.expanded]="expanded() === 'block'"
  [class.flat]="color() === 'flat'"
  [class.ghost]="color() === 'ghost'"
  [class.green]="color() === 'green'"
  [class.hold]="hold() === true"
  [class.lg]="size() === 'lg'"
  [class.lightgreen]="color() === 'lightgreen'"
  [class.md]="size() === 'md'"
  [class.pill]="expanded() === 'pill'"
  [class.primary]="color() === 'primary'"
  [class.secondary]="color() === 'secondary'"
  [class.sm]="size() === 'sm'"
  [class.tertiary]="color() === 'tertiary'"
  [class.xs]="size() === 'xs'"
  [class]="linkClass()"
  [href]="linkUrl()"
  [target]="linkTarget()"
>
  {{ linkTitle() }}
</a>

<button #button
        (click)="onClick.emit($event)"
        *ngIf="!(linkUrl() && linkTitle())"
        [class.apricot]="color() === 'apricot'"
        [class.btn-outline-green]="color() === 'outline-green'"
        [class.btn-outline-tertiary-green]="color() === 'outline-tertiary-green'"
        [class.btn-outline-tertiary]="color() === 'outline-tertiary'"
        [class.btn-outline]="color() === 'outline'"
        [class.bullet]="expanded() === 'bullet'"
        [class.compressed]="compressed() === true"
        [class.expanded]="expanded() === 'block'"
        [class.flat]="color() === 'flat'"
        [class.ghost]="color() === 'ghost'"
        [class.green]="color() === 'green'"
        [class.hold]="hold() === true"
        [class.lg]="size() === 'lg'"
        [class.lightgreen]="color() === 'lightgreen'"
        [class.md]="size() === 'md'"
        [class.pill]="expanded() === 'pill'"
        [class.primary]="color() === 'primary'"
        [class.secondary]="color() === 'secondary'"
        [class.sm]="size() === 'sm'"
        [class.tertiary]="color() === 'tertiary'"
        [class.xs]="size() === 'xs'"
        [class]="buttonClass()"
        [disabled]="disabled() || spinner()"
>
  <app-ui-icon *ngIf="spinner()" class="spinner m-0" name="spinner"></app-ui-icon>
  <ng-content *ngIf="!spinner()" select="app-ui-icon"></ng-content>
  <ng-content *ngIf="!spinner()"></ng-content>
</button>
